<template>
    <div v-if="auth">
        <v-toolbar color="primary" app fixed dark>
            <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
            <v-layout class="align-end justify-end">
                <a href="/"><img src="../assets/tp-logo-white.png" width="30px" height="30px"></a>
            </v-layout>
        </v-toolbar>

        <v-navigation-drawer v-model="drawer" :clipped="clipped" enable-resize-watcher app>
            <v-list v-for="item in this.$store.state.navigation" :key="item.page_id" dense class="pt-0 pb-0">
                <v-list v-if="!item.children" dense class="pt-0 pb-0">
                    <v-list-tile :to="item.page_path != '#' ? item.page_path : null" @click="item.page_path == '#' ? logout() : null">
                        <v-list-tile-action>
                            <v-icon>{{ item.page_icon }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-title>{{ item.page_name }}</v-list-tile-title>
                    </v-list-tile>
                </v-list>

                <v-list-group v-else no-action prepend-icon="folder">
                    <v-list-tile slot="activator">
                        <v-list-tile-title>{{ item.page_name }}</v-list-tile-title>
                    </v-list-tile>

                    <v-list-tile v-for="element in item.children" :key="element.page_id" :to="element.page_path">
                        <v-list-tile-action>
                            <v-icon>{{ element.page_icon }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-title>{{ element.page_name }}</v-list-tile-title>
                    </v-list-tile>
                </v-list-group>
            </v-list>
        </v-navigation-drawer>
        
        <!-- <v-navigation-drawer v-if="auth" v-model="drawer" :clipped="clipped" enable-resize-watcher app>
            <v-list v-for="item in items" :key="item.title" dense class="pt-0 pb-0">
                <v-list v-if="!item.items" dense class="pt-0 pb-0">
                    <v-list-tile :to="item.path">
                        <v-list-tile-action>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile>
                </v-list>

                <v-list-group v-else no-action prepend-icon="folder">
                    <v-list-tile slot="activator">
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile>

                    <v-list-tile v-for="element in item.items" :key="element.title" :to="element.path">
                        <v-list-tile-action>
                            <v-icon>{{ element.icon }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-title>{{ element.title }}</v-list-tile-title>
                    </v-list-tile>
                </v-list-group>
            </v-list>
        </v-navigation-drawer> -->
    </div>

    <div v-else>
        <v-toolbar color="primary" app fixed dark>
            <v-layout class="align-end justify-end">
                <a href="/"><img src="../assets/tp-logo-white.png" width="30px" height="30px"></a>
            </v-layout>
        </v-toolbar>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data () {
      return {
        // items: [
        //   { title: 'Dashboard', icon: 'dashboard', path: '/'},
        //   { title: 'Transactions', icon: 'swap_horiz', path: '/transactions', active: true },
        //   { title: 'Transactions v2', icon: 'swap_horiz', path: '/transactions-v2', active: true },
        //   { title: 'Critical Transactions', icon: 'error', path: '/critical-transactions', active: true },
        //   { title: 'eTerminal', icon: 'tablet_mac', path: '/eterminal' },
        //   { title: 'Reports', icon: '', path: '', items: [
        //     { title: 'Transactions Value', icon: 'assessment', path: '/transactions-value-report' },
        //     { title: 'Transactions Volume', icon: 'assessment', path: '/transactions-volume-report' },
        //     { title: 'Transactions Frequency', icon: 'assessment',  path: '/transactions-frequency-report' },
        //     { title: 'Value & Volume Comparison', icon: 'assessment',  path: '/value-volume-comparison-report' },
        //     { title: 'Sales Staff Report', icon: 'assessment',  path: '/sales-staff-report' },
        //     { title: 'Leads & Status Report', icon: 'assessment',  path: '/leads-status-report' } 
        //   ] },
        //   { title: 'Tools', icon: '', path: '', items: [
        //     { title: 'CSV Parser', icon: 'build', path: '/csv-parser' },
        //     { title: 'OnBoarder', icon: 'forward', path: '/onboarder' },
        //   ] },
        //   { title: 'Holidays', icon: '', path: '', items: [
        //     { title: 'Holidays', icon: 'wb_sunny', path: '/holidays' },
        //     { title: 'Holiday Requests', icon: 'assignment', path: '/holiday-requests' },
        //     { title: 'Add User', icon: 'person_add', path: '/onboarder' },
        //     { title: 'Add Site', icon: 'location_on', path: '/onboarder' },
        //     { title: 'Add Department', icon: 'playlist_add', path: '/onboarder' },
            
        //   ] },
        //   { title: 'Demos', icon: '', path: '', items: [
        //     { title: 'Server To Server - Test', icon: 'cast', path: '/server-to-server-test' },
        //     { title: 'Server To Server - Live', icon: 'cast', path: '/server-to-server-live' },
        //     { title: 'Server To Server - Registration', icon: 'cast', path: '/server-to-server-registration' }
        //   ] },
        //   { title: 'Logout', icon: 'input', path: '/logout' }
        // ],
        right: null,
        drawer: false,
        clipped: false,
        pageAccess: localStorage.page_access
        }
    },
    computed: {
        auth() {
            return this.$store.getters.isAuth;
        }
    },
    created() {

    },
    beforeMount() {
        
    },
    methods: {
        logout() {
            axios({
            method: 'post',
            url: 'https://controlapi.totalprocessing.com/api/logout',
            data: { userId: localStorage.user_id },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                localStorage.clear();
                this.$router.go('/login');
            })
            .catch(e => {
                this.errors.push(e)
            })
        }
    }
  }
</script>

<style>
    .v-navigation-drawer {
        padding-top: 10px;
    }

    .v-list__group__items a > .v-list__tile__title {
        overflow: unset;
    }

    .v-list__group__items > div > a {
        padding-left: 30px !important;
    }

    .v-list__tile__action {
        min-width: 40px !important;
    }

    .v-list__group .v-list__tile {
        padding: 0px;
    }
</style>